import { Component, ContentChild, HostBinding, Input, TemplateRef } from "@angular/core";

@Component({
	selector: "ic-container",
	templateUrl: "./container.component.html",
	styleUrls: ["./container.component.scss"],
	standalone: false,
})
export class ContainerComponent {
	@HostBinding("class.is-loading") @Input() loading = true;
	@Input() loadingText: string;
	@Input() error = false;
	@Input() errorText: string;
	@Input() context: Record<string, unknown>;

	/** Template for content. */
	@ContentChild("contentTmpl", { static: false }) contentTemplate: TemplateRef<any>;
}
